// extracted by mini-css-extract-plugin
module.exports = {"Header":"_7hzB61","Main":"apWlZE","Space":"FqEV_i","Center":"UrrGwD","coBrandedLogo":"m1hQzS"};